import React from 'react';
import ReactDOM from 'react-dom';
import OldDraggableCalendar from "./OldDraggableCalendar";

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<OldDraggableCalendar />, document.getElementById('root'));
